export default function updateProjectTitle(state, action) {
  const { updates } = action
  const { projects, currentProjectMetadata } = state

  if (!currentProjectMetadata) return state

  return Object.assign({}, state, {
    projects: projects
                .filter(p => p.id !== currentProjectMetadata._id)
                .concat(Object.assign({}, projects.find(p => p.id === currentProjectMetadata._id), updates))
  })
}



// WEBPACK FOOTER //
// ./src/reducers/updateProject.js